import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {
  CUSTOM_SHADOW_MAX_ALPHA,
  CUSTOM_SHADOW_MAX_DISPLAY_ALPHA,
  CUSTOM_SHADOW_MIN_ALPHA,
  CUSTOM_SHADOW_MIN_DISPLAY_ALPHA,
} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-custom-shadow-opacity-option/base-item-custom-shadow-opacity-option.types';

interface BaseItemCustomShadowOpacityOptionProps {
  dropShadowAlpha: number;
  className?: string;
  onUpdateOpacity(dropShadowAlpha: number, undoable?: boolean): void;
}

export function BaseItemCustomShadowOpacityOption({className = '', ...props}: BaseItemCustomShadowOpacityOptionProps): ReactElement<any> | null {
  const onChangeOpacity = (updatedOpacity: number): void => {
    props.onUpdateOpacity(updatedOpacity, false);
  };

  const onChangeOpacityEnded = (updatedOpacity: number): void => {
    props.onUpdateOpacity(updatedOpacity);
  };

  return (
    <ContextualMenuSliderOptions
      id="custom-shadow-opacity"
      className={className}
      value={props.dropShadowAlpha}
      label={window.i18next.t('pmwjs_opacity')}
      range={{
        min: CUSTOM_SHADOW_MIN_ALPHA,
        max: CUSTOM_SHADOW_MAX_ALPHA,
      }}
      transformDisplay={{
        min: CUSTOM_SHADOW_MIN_DISPLAY_ALPHA,
        max: CUSTOM_SHADOW_MAX_DISPLAY_ALPHA,
      }}
      onChange={onChangeOpacity}
      onChangeEnded={onChangeOpacityEnded}
    />
  );
}
